import AppDispatcher from "../../../flux/dispatcher/dispatcher";
import Constant from "../constant/Constants";
import restClient from "../../MainFrame/action/APIClient";
import LogoutConstant from "../../MainFrame/constants/Constants";

var GetReviewResponseHistogramAction = function () {};

GetReviewResponseHistogramAction.prototype = {
	getReviewResponseHisto: function (data) {
		restClient.getReviewResponseHistogram(data, function (error, response) {
			if (error) {
				if (error.status === 401) {
					AppDispatcher.dispatch({
						actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
						data: error,
					});
				} else {
					AppDispatcher.dispatch({
						actionType: Constant.GET_REVIEW_RESPONSE_HISTOGRAM,
						data: error,
					});
				}
			} else if (response != null) {
				response["status"] = 200;
				AppDispatcher.dispatch({
					actionType: Constant.GET_REVIEW_RESPONSE_HISTOGRAM,
					data: response,
				});
			}
		});
	},
};

export default new GetReviewResponseHistogramAction();
